import * as React from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface Props {
  pressed: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

export const ToolbarToggle: React.FC<Props> = ({ pressed, onClick, children }) => (
  <Button
    type="button"
    size="xs"
    variant="light-beige-secondary"
    aria-pressed={pressed}
    onClick={onClick}
    className={cn({ "bg-ivory-mist-400 font-semibold": pressed })}
  >
    {children}
  </Button>
);
